import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-lg shadow p-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "How do you like the deal?", -1)
const _hoisted_3 = { class: "flex items-center justify-start mt-2 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onClick('#quote-submit')), ["prevent"])),
            class: "block cursor-pointer font-medium text-sm text-white bg-green-600 hover:bg-green-800 rounded-md mr-2 py-1 px-2.5 focus:outline-none border-none"
          }, " Submit a Soft Quote "),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onClick('#quote-request')), ["prevent"])),
            class: "block cursor-pointer font-medium text-sm text-sky bg-indigo-100 hover:bg-sky hover:text-white rounded-md mr-2 py-1 px-2.5 focus:outline-none border-none mt-1.5"
          }, " Request information "),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onClick('#quote-reject')), ["prevent"])),
            class: "block cursor-pointer font-medium text-sm text-white bg-red-500 hover:bg-red-600 hover:text-white rounded-md py-1 px-2.5 focus:outline-none border-none mt-1.5"
          }, " This isn't a fit ")
        ])
      ]))
    : _createCommentVNode("", true)
}